import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=2a931f44&scoped=true&lang=css"

import exportComponent from "/Users/beiyu/Documents/web/森瑶/web/senyao-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a931f44"]])

export default __exports__